/**
 * KeyboardEvent.key special values
 */
export enum Keys {
	Down = 'Down', // Edge/IE
	DownArrow = 'ArrowDown',
	End = 'End',
	Enter = 'Enter',
	Esc = 'Esc', // Edge/IE, Old Firefox
	Escape = 'Escape',
	Home = 'Home',
	Left = 'Left', // Edge/IE
	LeftArrow = 'ArrowLeft',
	PageDown = 'PageDown',
	PageUp = 'PageUp',
	Right = 'Right', // Edge/IE
	RightArrow = 'ArrowRight',
	Space = ' ',
	Spacebar = 'Spacebar', // Old Firefox, IE
	Tab = 'Tab',
	Up = 'Up', // Edge/IE
	UpArrow = 'ArrowUp'
}
